import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createIntegrationLink } from "@/app/Settings/Settings/GraphQL/integrationLinkMutations";
import { SupplierOfficeInput } from "@/app/Offices/Components/SupplierOfficeInput";
import { SelectInput } from "@/lib/Components/Form/Inputs/SelectInput";
import { ModelType } from "@/gql/graphql";
import { click4WheelsStations } from "@/app/Settings/Integrations/Click4Wheels/click4WheelsStations";

export function Click4WheelsLinkDialog({
  integrationId,
  supplierId,
}: {
  integrationId: string;
  supplierId: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(createIntegrationLink);

  return (
    <BaseDialog title="Link office to station" size="sm">
      <GenericForm
        initialValues={{
          office_id: null! as string,
          station_code: "",
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: {
              external_id: values.station_code,
              object: {
                connect: {
                  id: values.office_id,
                  type: ModelType.SupplierOffice,
                },
              },
              integration: { connect: integrationId },
            },
          });
          close();
        }}
      >
        <SupplierOfficeInput
          name="office_id"
          label="Office"
          supplierId={supplierId}
          className="col-span-full"
        />
        <SelectInput
          name="station_code"
          label="Click4Wheels station"
          className="col-span-full"
          options={[
            {
              label: "Stations",
              options: click4WheelsStations.map((station) => ({
                label: `${station.name} (${station.code})`,
                value: station.code,
              })),
            },
          ]}
        />
        <DialogSubmitButton text="Link" />
      </GenericForm>
    </BaseDialog>
  );
}
